// import React from "react";
import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

// /Components
import Header from '../components/header'
import Footer from '../components/footer'
import useGaspAnimations from '../components/useGsapAnimations'
import MakeAppoinment from '../components/make-appoinment';

function About() {
    useGaspAnimations()

 const lenis = new Lenis({ 
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      };


    //   var settings2 = {
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    //     initialSlide: 0,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 3,
    //           infinite: true,
    //           dots: true
    //         }
    //       },
    //       {
    //         breakpoint: 600,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 3,
    //           initialSlide: 2
    //         }
    //       },
    //       {
    //         breakpoint: 480,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 2
    //         }
    //       }
    //     ]
    //   };



   return(
     <section id="smooth-wrapper">
         <Header/>
         <main>
         {/* <!--Start breadcrumb area-->      */}
<section className="breadcrumb-area">
	<div className="container text-center">
          <div className="sec-title">
            <h1 className="title-anim"><span>About Us</span></h1>
        </div>
	</div>
</section>
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">About Us</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start about us area--> */}
{/* <section className="about-us-area">
    <div className="container">
        
    </div>
</section> */}
{/* <!--End about us area--> */}

{/* <!--Start about us area--> */}
<section className="services-page-area about-us-area footer-area">
    <div className="container">
          <div className="row">
  <div className="sec-title">
            <h1 className="title-anim"><span>Company Profile</span></h1>
        </div>
        <div className="row">
            <div className="col-md-4 bdFadeLeft">
                <div className="img-holder">
                    <img src="assets/images/About-Us.png" alt="indusrefServices"/>
                </div>    
            </div>
            <div className="col-md-6 bdFadeRight">
                <div className="middle-text-box">
                    <div className="single-item top">
                       
                        <p className="bdFadeRight">
                            Indus Refrigeration Pvt. Ltd is an established EPC  company specialized in Industrial Refrigeration and Process Cooling  for diverse industries like  Petrochemical, Pharmaceutical, Dairy ,Sea food, RTE, Meat, Poultry, Fruits & Vegetables,  Beverage and  Cold storage.
                            Founded in 1999 by Mr. D. Varadarajakumar ,a technocrat turned entrepreneur specialized in Green Industrial Refrigeration with three decades of experience in Process cooling and Refrigeration . He has worked with leading Indian and International companies such as Blue Star Ltd., Frigoscandia (JBT) Sweden and York Refrigeration, USA. 
                        </p>
                        <p className="bdFadeRight">
                            Today a strong team of 200  highly experienced and qualified  designers , site engineers, skilled riggers, fabricators, welders, insulation and cladding experts operate out of a fully equipped modern factory infrastructure modeled on Japanese Quality management principles at Madanapalle, Andhra Pradesh (140km from Bengaluru)
                            With a goal to accelerate Industrial Refrigeration towards sustainable, energy efficient  and eco-friendly cooling and heating solutions , we at Indus Refrigeration strive to bring world class natural refrigerant based technology with unmatched quality and service to our customers at  a cost effective and efficient manner .
                            Apart from providing cost effective and energy efficient natural refrigeration systems 
                        </p>
                    </div> 
                </div>
            </div>
           
        </div>

          </div>
    </div>
</section>

{/* <!--Start about us area--> */}
<section className="services-page-area about-us-area">
    <div className="container">
        <div className="row">
          

        <div className="row top-content-scale">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>

       <div className="cointainer">
          <div className="row">
             {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/facility.JPG" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                         <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 1024 1024" className="icon" version="1.1" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M309.2 584.776h105.5l-49 153.2H225.8c-7.3 0-13.3-6-13.3-13.3 0-2.6 0.8-5.1 2.2-7.3l83.4-126.7c2.5-3.6 6.7-5.9 11.1-5.9z" fill="#FFFFFF"/><path d="M404.5 791.276H225.8c-36.7 0-66.5-29.8-66.5-66.5 0-13 3.8-25.7 11-36.6l83.4-126.7c12.3-18.7 33.1-29.9 55.5-29.9h178.4l-83.1 259.7z m-95.3-206.5c-4.5 0-8.6 2.2-11.1 6l-83.4 126.7c-1.4 2.2-2.2 4.7-2.2 7.3 0 7.3 6 13.3 13.3 13.3h139.9l49-153.2H309.2z" fill="#333333"/><path d="M454.6 584.776h109.6l25.3 153.3H429.3z" fill="#FFFFFF"/><path d="M652.2 791.276H366.6l42.8-259.6h200l42.8 259.6z m-222.9-53.2h160.2l-25.3-153.3H454.6l-25.3 153.3z" fill="#333333"/><path d="M618.6 584.776h105.5c4.5 0 8.6 2.2 11.1 6l83.5 126.7c4 6.1 2.3 14.4-3.8 18.4-2.2 1.4-4.7 2.2-7.3 2.2H667.7l-49.1-153.3z" fill="#FFFFFF"/><path d="M807.6 791.276H628.9l-83.1-259.7h178.4c22.4 0 43.2 11.2 55.5 29.9l83.4 126.7c9.8 14.8 13.2 32.6 9.6 50s-13.7 32.3-28.6 42.1c-10.8 7.2-23.5 11-36.5 11z m-139.9-53.2h139.9c2.6 0 5.1-0.8 7.3-2.2 4-2.6 5.3-6.4 5.7-8.4 0.4-2 0.7-6-1.9-10l-83.4-126.6c-2.5-3.8-6.6-6-11.1-6H618.6l49.1 153.2z" fill="#333333"/><path d="M534.1 639.7C652.5 537.4 711.7 445.8 711.7 365c0-127-102.7-212.1-195-212.1s-195 85.1-195 212.1c0 80.8 59.2 172.3 177.7 274.7 9.9 8.6 24.7 8.6 34.7 0z" fill="#ffffff"/><path d="M516.7 672.7c-12.5 0-24.9-4.3-34.8-12.9C356.2 551.2 295.1 454.7 295.1 365c0-142.8 114.6-238.7 221.6-238.7S738.3 222.2 738.3 365c0 89.7-61.1 186.2-186.9 294.8-9.8 8.6-22.3 12.9-34.7 12.9z m0-493.2c-79.7 0-168.4 76.2-168.4 185.5 0 72.3 56.7 158 168.4 254.6C628.5 523 685.1 437.3 685.1 365c0-109.3-88.7-185.5-168.4-185.5z" fill="#333333"/><path d="M516.7 348m-97.5 0a97.5 97.5 0 1 0 195 0 97.5 97.5 0 1 0-195 0Z" fill="#FFFFFF"/><path d="M516.7 472.1c-68.4 0-124.1-55.7-124.1-124.1s55.7-124.1 124.1-124.1S640.8 279.5 640.8 348 585.1 472.1 516.7 472.1z m0-195.1c-39.1 0-70.9 31.8-70.9 70.9 0 39.1 31.8 70.9 70.9 70.9s70.9-31.8 70.9-70.9c0-39.1-31.8-70.9-70.9-70.9z" fill="#333333"/></g></svg>
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                         <h3>Location </h3>
                         <p>
                            Located in an Industrial Park, Valasapalle,<br/>
                            Madanapalle , about 120 km from Bengaluru. <br/>
                            The total enclosed land area of 1.55 Acres with more than 1000 Sqmtrs dedicated manufactuing space .
                         </p>
                       
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
     
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/facility.jpeg" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                           <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="50px" width="45px" version="1.1" id="Layer_1" viewBox="0 0 512.001 512.001"><g><g><path d="M480.858,380.355v-30.421H512v-30.417h-31.143H470.41h-70.6H296.523h-6.228h-30.417h-44.402H112.189H41.59H31.143H0 v30.417h31.143v30.421H0v30.417h31.143h81.047h103.286h81.047h103.286h81.047h31.143v-30.417H480.858z M215.477,380.355H112.19 v-30.421h103.286V380.355z M399.811,380.355H296.524v-30.421h103.286V380.355z"/></g></g><g><g><polygon points="181.151,101.229 181.151,142.934 150.734,142.934 150.734,101.229 72.007,101.229 72.007,289.1 259.879,289.1 259.879,108.986 259.879,101.229 "/></g></g><g><g><polygon points="380.353,139.403 380.353,181.108 349.936,181.108 349.936,139.403 290.296,139.403 290.296,289.1 439.993,289.1 439.993,139.403 "/></g></g></svg>
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3> Facilities</h3>
                       <p>
                        Connected Power 125 KVA <br/>
                        14 Ton Crane Facility, 12Mtr Boom<br/>
                        MIG , TIG welding with mobile trolleys.<br/>
                        Water pressure testing facilities – 35<br/>
                        bar (Capacity upto 70 bar)<br/>
                       </p>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

          </div>
       </div>
        <div className="service-single-content service-li">
     <div className="row middle-content">
                        <div className="col-md-7">
                            <div className="text-holder">
                                <div className="title sec-title">
                                      <h1 className='title-anim'><span>Capabilities</span></h1>
                                    
                                    <ul>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Engineering Design and Development </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Refrigeration Engineering </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Pressure Vessel manufacturing  and testing </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Heat Exchanger manufacturing </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Sheet metal fabrication </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Surface coating </li>		
                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> Electrical Control Panel and Instrumentation</li>	
                             <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"/> IOT and Automation</li>		
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                    </div>
        </div>
  
        
        <div className="row bottom">
            <div className="sec-title">
            <h1 className="title-anim"><span>INDUS offers a wide range of products and services that includes:</span></h1>
            <p className="title-anim">
                Chiller Packages, Atmospheric Gas Vaporizer, Heat Pumps, Slurry Ice System, RSW Package ,Condenser, Cold Stores & Cold Chain Systems, Heat Exchangers, Air Cooling Coils, Pressure Vessels, Air Purger, Process Refrigeration Audits and Design & Implementation Consultancy.
             </p>
        </div>
           
            
        </div>
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Industrial-Refrigeration-Refpacks.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Productiocns/01-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                         <h3>Skid Mounted Refrigeration Pack</h3>
                        <ul>
                            <li className='clouser'>Low Charge Ammonia</li>
                                                        <li className='clouser'>Pump feed Ammonia </li>
                                                        <li className='clouser'>Freon DX </li>
                                                        <li className='clouser'>CO2  Subcritical </li>
                                                        <li className='clouser'>CO2 Transcritical</li>
                        </ul>
                        <a href="/industrial-refrigeration" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Cooling-&-Chilling-Systems.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/02-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                        <h3>Process Refrigeration Systems </h3>
                         <ul>
                              <li className='clouser'>Process & Instant Milk Chiller</li>
                                                    <li className='clouser'>Refrigerated Sea Water </li>
                                                    <li className='clouser'>Boil Off Gas Condensing system</li>
                                                    <li className='clouser'>Gas Liquification</li>
                                                    <li className='clouser'>Turbine Inlet Air cooling system</li>
                                                    <li className='clouser'>CO2 Atmospheric & Vapouriser</li>
                         </ul>

                        <a href="/cooling-and-chilling" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Heat-Pumps.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/03-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                          <h3>Heat Pumps</h3>
                    <ul className="pull-left">
                       <li className='clouser'>Air Source Heat Pump</li>
                                                    <li className='clouser'>Water Source Heat Pump</li>
                                                    <li className='clouser'>Dual Source Heat Pump</li>
                                                    <li className='clouser'>Hybrid Heat Pump</li>

                    </ul>
                        <a href="/heat-pumps" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Container-Plant.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/04-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3> ICE Production Systems</h3>

                    <ul className="pull-left">
                        <li className='clouser'>Block & Flake ice systems</li>
                                                    <li className='clouser'>Tube ice systems</li>
                                                    <li className='clouser'>Plate / slice ice systems </li>
                                                    <li className='clouser'>Slurry ice systems </li>
                                                    <li className='clouser'>Cube / commercial ice systems</li>
                    </ul>
                        <a href="/ICE-production-systems" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Economizer.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/05-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                               <h3>Ammonia Liquid  Recirculator Package</h3>
                    <ul className="pull-left">
                         <li className='clouser'>Ice Manufacturing</li>
                                                    <li className='clouser'>Cold Storage</li>
                                                    <li className='clouser'>Food Processing</li>
                                                    <li className='clouser'>Dairy & Beverage</li>
                    </ul>
                        <a href="/ammonia-recirculator-package" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/cooledcondenser.jpg" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/09-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                           <h3>Cooling Condenser</h3>

                    <ul className="pull-left">
                         <li className='clouser'>Evaporative Condensor</li>
                                                    <li className='clouser'>Shell and Tube water cooled</li>
                                                    <li className='clouser'>Air cooled</li>   
                    </ul>
                        <a href="/cooling-condenser" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

             {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/IQF_Freezer_Dairy_370x200.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/10-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3>Freezers</h3>

                    <ul className="pull-left">
                        <li className='clouser'>IQF & Blast Freezer </li>
                                                    <li className='clouser'>Contact Freezer </li>
                                                    <li className='clouser'>Compact Freezer </li>
                                                    <li className='clouser'>Fluidised bed Freezer</li>
                                                    <li className='clouser'>Brine Freezer</li>
                    </ul>

                        <a href="/pressure-vessels" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}


                {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Pressure-Vessels.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/07-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                       <h3>Pressure Vessels</h3>

                    <ul className="pull-left">
                     <li className='clouser'>Suction Accumulators</li>
                                                    <li className='clouser'>Receivers</li>
                                                    <li className='clouser'>Chiller Barrels and Subcoolers</li>
                                                    <li className='clouser'>Oil Separators</li>
                    </ul>

                        <a href="/pressure-vessels" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}


               {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Support-Services-.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img src='assets/images/Productiocns/08-black.webp' alt='icons'/> 
                        </div>
                    </div>
                    <div className="text-holder flex-flow-col">
                      <h3> Control Systems</h3>
                        <ul>
               
                            <li className='clouser'>Sensors and Controls </li>
                                                        <li className='clouser'>Control Panel</li>
                                                        <li className='clouser'>SCADA system</li>
                                                        <li className='clouser'>Automation</li>
                                                        <li className='clouser'>Monitoring Software</li>
                        </ul>
                        <a href="/control-systems" className="col-md-12">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

             
        </div>
    </div>
</section>
{/* <!--Start Brand area-->   */}


<section className="services-page-area">
    <div className="container">
        <div className="row">

              <div className="sec-title">
            <h1 className="title-anim"><span>Segments</span></h1>
          
        </div>
           
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/01.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/01.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Food</h3>
                        <p>Refrigeration solutions to ensure food freshness and safety.</p>
                        <a href="/market-food">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/02.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/02.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Dairy</h3>
                        <p>Energy-efficient refrigeration systems</p>
                        <a href="/market-dairy">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/03.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/07.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Industrial HVAC</h3>
                        <p>We custom-engineer HVAC for industrial and commercial applications.</p>
                        <a href="/market-HVAC">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/04.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/03.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Beverage</h3>
                        <p>Reliable refrigeration for efficient beverage manufacturing and quality.</p>
                        <a href="/market-beverage">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/05.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                              <img src='assets/images/Marketicons/04.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Pharma</h3>
                        <p>Precise refrigeration for pharmaceutical safety and compliance
</p>
                        <a href="/market-pharma">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/06.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                              <img src='assets/images/Marketicons/05.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Oil / Gas / Chemical / Power</h3>
                        <p>Robust refrigeration for the oil, gas, and chemical industries.</p>
                        <a href="/market-oil-gas-chemical">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

             {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/07.webp" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                             <img alt="icons" src="assets/images/Marketicons/06.webp"/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Cold Storage & WareHouse</h3>
                        <p>Integrated cold storage for temperature-sensitive goods</p>
                        <a href="/market-Cold-Storage-and-WareHouse">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

               {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Negative-Storage-722x368.jpg" alt="indusrefServices"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                         <img src='assets/images/Marketicons/08.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>General Industries</h3>
                        <p>Industrial refrigeration plays a critical role across a wide range of general industrial sectors</p>
                        <a href="/market-General-Industries">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
        </div>
    </div>
</section>

      {/* <!--Start Brand area-->   */}
                    <section className="brand-area bdFadeRight">
                        <div className="container">
                            <div className="sec-title center text-center">
                                <h1><span>Our Clients</span></h1>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="brand">
                                    <Slider {...settings}>
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/1.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/2.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/3.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/4.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/5.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/6.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/7.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/8.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/9.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/10.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End Brand area-->      */}

 {/* <!--Start appoinment area--> */}
               <MakeAppoinment/>
                    {/* <!--End appoinment area--> */}


                    

{/* <section className="choose-us-area">
       <div className="container">
         <div className="middle-text-box">
                    <div className="singleitem top">
                      
                    </div> 
                    <div className="singleitem">
                        <h3>INDUS offers a wide range of products and services that includes:</h3>
                        <p>
                           
Chiller Packages, Atmospheric Gas Vaporizer, Heat Pumps, Slurry Ice System, RSW Package ,Condenser, Cold Stores & Cold Chain Systems, Heat Exchangers, Air Cooling Coils, Pressure Vessels, Air Purger, Process Refrigeration Audits and Design & Implementation Consultancy.
                        </p>
                    </div>     

                      <div className="singleitem">
                        <h3> Products</h3>
                        <p>
                            ​Industrial Refrigeration -Refpacks<br/>
                            Limited Charge Ammonia Walrus RefPacks<br/>
                            Ammonia DX Walrus Refpack<br/>
                            CO2 Cascade Subcritical GreenTon RefPack<br/>
                            CO2 Transcritical GreenTon RefPack<br/>
                        </p>
                    </div>     


                <div className="singleitem">
                        <h3>​Process Cooling and Chilling Systems</h3>
                        <p>
                          
                           Water and Brine Chilling plants<br/>
                           Refrigerated Seawater (RSW) Chillers<br/>
                           Ice making Plants<br/>
                           CO2  atmospheric Vaporizer<br/>
                           Boil Out Gas  cooling package
                        </p>
                    </div>     
     

                       <div className="singleitem">
                        <h3> Heat Pumps<br/>
                            ​Air Purger<br/>
                            ​Economizer<br/>
                            ​Condenser<br/>
                            ​Pressure Vessels</h3>
                    </div>          

                      <div className="singleitem">
                        <h3> ​Technical Support & Services</h3>
                        <p>
                       
                           
                            Refrigeration Plant Audits<br/>
                            Energy Audits<br/>
                            Refrigeration Plant and Process design<br/>
                            EPC Project Consulting<br/>
                            Special Purpose Projects<br/>
                            Annual Maintenance Contracts
                        </p>
                    </div>     

                </div>
       </div>
</section> */}
 {/* <!--Start team area--> */}
{/* <section className="team-section">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="sec-title">
                    <h1><span>Meet Our Team</span></h1>
                </div>
            </div> 
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="team-carousel">
                     <Slider {...settings2}>
                    <div className="single-team-member">
                        <div className="img-holder">
                            <img src="assets/images/team/1.jpg" alt="indusrefServices"/>
                            <div className="overlay-one">
                                <div className="overlay-inner">
                                    <div className="content">
                                        <ul>
                                            <li><a href="/"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-holder">
                            <h3>Vena Georgeyo</h3>
                            <span>Founder</span>
                        </div>    
                    </div> 
                   
                    <div className="single-team-member">
                        <div className="img-holder">
                            <img src="assets/images/team/2.jpg" alt="indusrefServices"/>
                            <div className="overlay-one">
                                <div className="overlay-inner">
                                    <div className="content">
                                        <ul>
                                            <li><a href="/"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-holder">
                            <h3>Johny Zabrila</h3>
                            <span>Supervisor</span>
                        </div>    
                    </div> 
                   
                    <div className="single-team-member">
                        <div className="img-holder">
                            <img src="assets/images/team/3.jpg" alt="indusrefServices"/>
                            <div className="overlay-one">
                                <div className="overlay-inner">
                                    <div className="content">
                                        <ul>
                                            <li><a href="/"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-holder">
                            <h3>Philil Burphly</h3>
                            <span>Technician</span>
                        </div>    
                    </div> 
                
                    <div className="single-team-member">
                        <div className="img-holder">
                            <img src="assets/images/team/4.jpg" alt="indusrefServices"/>
                            <div className="overlay-one">
                                <div className="overlay-inner">
                                    <div className="content">
                                        <ul>
                                            <li><a href="/"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                                            <li><a href="/"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-holder">
                            <h3>Michal Wincent</h3>
                            <span>Manager</span>
                        </div>    
                    </div> 
                 
                    </Slider>
                </div>
            </div>
        </div>
    </div>
</section> */}
{/* <!--End team area--> */}

{/* <!--Start project area--> */}
{/* <div className="project-area">
    <div className="container-fluid">
        <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-1.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
           
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-2.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
          
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-3.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
      

      <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-3.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>


            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-3.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>

            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12 pd0">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/Events/Events-3.webp" alt="indusrefServices"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="/">View More</a>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>

          
           
        </div>
    </div>    
</div> */}
{/* <!--End project area--> */}

         </main>
         <Footer/>
     </section>
   )
}

export default About;
